import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/transportistas.css"; 

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

function capitalize(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default function Transportistas() {

  const location = useLocation();
  const [transportistas, setTransportistas] = useState([]);
  const [tipoActivo, setTipoActivo] = useState("terrestre");
  const navigate = useNavigate();

  const tipos = [
    { id: "terrestre", label: "Terrestre", icon: "fas fa-truck" },
    { id: "ferrocarril", label: "Ferrocarril", icon: "fas fa-train" }, 
  ];

  useEffect(() => {
    if (location.state && location.state.tipo) {
      setTipoActivo(location.state.tipo);
    }
  }, [location]);

  useEffect(() => {
    if (tipoActivo === "ferrocarril") {
      document.body.classList.add("body-fondo-ferrocarril");
    } else {
      document.body.classList.remove("body-fondo-ferrocarril");
    }

    fetch(`${API_BASE_URL}/api/transportistas/tipo/${tipoActivo}`)
      .then((res) => res.json())
      .then((data) => setTransportistas(data))
      .catch(() => setTransportistas([]));

    return () => {
      document.body.classList.remove("body-fondo-ferrocarril");
    };
  }, [tipoActivo]);

  const irADetalle = (id) => {
    navigate(`/transportista/${id}`);
  };

  return (
    <div className="transportistas"> 
      <div className="tabs-container">
        {tipos.map((tipo) => (
          <div
            key={tipo.id}
            className={`tab ${tipoActivo === tipo.id ? "active" : ""}`}
            onClick={() => setTipoActivo(tipo.id)}
          >
            <i className={tipo.icon}></i>
            <span>{tipo.label}</span>
          </div>
        ))}
      </div>

      <div className="contenedor-transportistas">
        <h2>{capitalize(tipoActivo)}</h2>
        
        {tipoActivo === "terrestre" && (
          <p>Transportistas terrestres mueven mercancía por carretera.</p>
        )}
        {tipoActivo === "ferrocarril" && (
          <p>Transportistas ferroviarios mueven mercancía por vías de tren.</p>
        )}
        
        <div className="lista-transportistas"> 
          {transportistas.length === 0 ? (
            <p>No hay transportistas registrados en esta categoría.</p>
          ) : (
            transportistas.map((transportista) => (
              <div
                key={transportista.id}
                className="tarjeta-transportista" 
                onClick={() => irADetalle(transportista.id)}
              >
                <img 
                  src={transportista.urlImagen || "/assets/logo_placeholder.png"} 
                  alt={`Logo de ${transportista.nombre}`}
                  referrerPolicy="no-referrer"
                />
                <h4>{transportista.nombre}</h4>
                <p>{transportista.estado}, {transportista.municipio}</p>
                <p>Puntuación:</p>
                <div className="estrellas">⭐⭐⭐⭐⭐</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}